var EVENT_COOKIE_CONSENT_SHOW = 'show-cookie-consent';
var EVENT_COOKIE_CONSENT_HIDE = 'hide-cookie-consent';
var EVENT_VIDEO_SHOW = 'show-video';
var EVENT_BULLETIN_SEARCH = 'bulletin-search';

var EVENT_ACCORDION = {
    ITEM_SELECTED: 'accordion-item-selected',
    ITEM_CLICKED: 'accordion-item-selected'
};

var MpEventBus = new Vue();